import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useAdminImportCustomsError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      await request({
        path: 'customs-error/import',
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['admin-customs-errors-list'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Failed to import customs errors');
    },
  });
};
